(function($, undefined) {
  let activity = function() {
    this.refsrc = commonObj.utils.getQueryStrFn('refsrc') || 'none';
    this.siteId = '1276136459';
    this.downloadBtn = $('#downloadBtn');
    this.outCB = commonObj.data.outChangba;
    this.times = localStorage.getItem("wap_times") || 0; ;//记录点击第几次item
    this.video = document.getElementById('video');
    this.shareParams = {
      title: document.body.dataset.title || '唱吧短视频',
      content: '更多有趣、有料短视频，尽在唱吧！',
      thumburl: 'http://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
      link: 'https://changba.com/njwap/wapplay/clips/index/main?workid=' + commonObj.utils.getQueryStrFn('workid')
    };
    this.againPlay = $('#again-play');
    this.onPlay = $('#on-play')
    this.loading = $('#loading');
  };

  activity.prototype.init = function() {
    let _czc = this._czc = window._czc || [], self = this;
    if (_czc) {
      _czc.push(["_setAccount", this.siteId]);
      _czc.push(["_trackEvent", this.refsrc, commonObj.data.outChangba ? 'outCB' : 'inCB', 'loaded', 0, 'body']);
    }
    //iphoneX在qq里面的宽度少了1px。。。。。
    // alert(window.innerWidth)
    // alert(window.WeixinJSBridge)
    let shareParams = {
      title: this.shareParams.title,
      content: this.shareParams.content,
      weibocontent: this.shareParams.title,
      imageurl: this.shareParams.thumburl,
      thumburl: this.shareParams.thumburl,
      targeturl: this.shareParams.link + '&refsrc=share'
    };
    window.setShareUrlParams = function() {
      return JSON.stringify(shareParams);
    };
    commonObj.data.setWXShare = function(wx) {
      let shareData = {
        title: self.shareParams.title,
        link: self.shareParams.link + '&refsrc=wechatshare',
        imgUrl: self.shareParams.thumburl,
        desc: self.shareParams.content,
        success: function() {
          self._czc.push(["_trackEvent", '微信分享成功', 'loaded', self.refsrc, 0, 'body']);
        },
        cancel: function() {
          self._czc.push(["_trackEvent", '微信分享取消', 'loaded', self.refsrc, 0, 'body']);
        }
      };
      wx.onMenuShareTimeline(shareData);
      wx.onMenuShareAppMessage(shareData);
      wx.onMenuShareQQ(shareData);
      wx.onMenuShareWeibo(shareData);
      wx.onMenuShareQZone(shareData);
    };
    //独立显示上部分打开tab
    if (this.outCB) {
      $('#openAppBar').css('display', 'flex');
      // $('body').addClass('open-body');
    }
    this.bindEvents();
  };

  activity.prototype.bindEvents = function() {
    let self = this;
    if (!self.outCB) {
      window.location.href = 'changba://?ac=playshortvideo&workid=' + commonObj.utils.getQueryStrFn('workid');
      return false;
    }

    if (self.video) {
      self.video.addEventListener('ended', function() {
        // $('.video-wrapper').addClass('video-pause');
        $('#on-play').hide();
        $('#again-play').addClass('ml');
        $('.pause-wrapper').show();
      })

      self.video.addEventListener('play', function() {
        console.log('play')
        if (self.video.readyState != 4) {
          self.loading.show();
          var intervalId = setInterval(function() {
            if (self.video.readyState === 4) {
              clearInterval(intervalId);
              self.loading.hide();

              // console.log($('.video-wrapper').classList)
              $('.video-wrapper').classList && $('.video-wrapper').classList.contains('video-pause') && $('.video-wrapper').classList.remove('video-pause');
            }
          }, 1000)
        } else {
          console.log('准备好了')
        }
      });
      self.video.addEventListener('pause', function() {
        self.getRankWork()
        $('#again-play').removeClass('ml');
        $('#on-play').show();
        $('.pause-wrapper').show();
      });

    }
    this.againPlay.on('click', function() {
      console.log('again')
      self.video.currentTime = 0;
      $('.pause-wrapper').hide();
      self.video.play()
    })
    this.onPlay.on('click', function() {
      console.log('continue')
      $('.pause-wrapper').hide();
      self.video.play()
    })
    this.downloadBtn.on('click', function() {
      // console.log(`changba://?ac=takesameshortvideo&type=${self.type}&dataid=${self.dataid}`)
      if (self.outCB) {
        commonObj.utils.openApp(false, 'changba://?ac=playshortvideo&workid=' + commonObj.utils.getQueryStrFn('workid'), $('body'), 'http://changba.com/d');
        return false;
      }
    })
    $('.video-wrapper').on('click', function() {
      let videoWrapper = this;
      if (self.video.paused) {

        let playPromise = self.video.play();

        if (playPromise !== undefined) {
          playPromise.then(function() {})
            .catch(function(error) {
            });
        }
        videoWrapper.classList.contains('video-pause') && videoWrapper.classList.remove('video-pause');
      }
      else {
        self.video.pause();
        // videoWrapper.classList.add('video-pause')
      }
    })

    $('.aside-menu').on('click', '.aside-item', function() {
      self._czc.push(["_trackEvent", this.dataset.id, '', 'loaded', 0, 'body']);
      if (self.outCB) {
        commonObj.utils.openApp(false, location.href, $('body'), 'https://changba.com/d');
        return false;
      }
    })

    $('.main-info').on('click', '.headphoto, .nickname, .icon-follow, .topic-tag, .edit-input, .bg-music', function() {
      self._czc.push(["_trackEvent", this.dataset.id, '', 'loaded', 0, 'body']);
      if (self.outCB) {
        commonObj.utils.openApp(false, location.href, $('body'), 'https://changba.com/d');
        return false;
      }
    })
    $('.feed-list').on('click', 'li', function() {
      //    console.log(this)
      const workid = $(this).attr('data-id');
      if (self.times <= 0) {
        localStorage.setItem('wap_times', 1)
        location.href = `/njwap/wapplay/clips/index/main?workid=${workid}`;
      } else {
        commonObj.utils.openApp(false, `changba://?ac=playshortvideo&workid=workid=${workid}`, $('body'), 'https://changba.com/d');
        localStorage.setItem('wap_times', 0)
        return;
      }

    })
    $('.close-btn').on('click', function() {
      $('.pause-wrapper').hide();
      $('.video-wrapper').addClass('video-pause');
    })

  };
  activity.prototype.getRankWork = function() {
    $.ajax({
      url: '/api/newversion/shortVideoPlay/shortVideoRecommend',
      type: 'POST',
      dataType: 'json',
      success: function(res) {

        if (res.code && res.code === 1) {
          $(".feed-list li").remove();
          let str = '', data = res.data;
          console.log(data, 'data')
          for (let i = 0; i < (data && data.length); i++) {
            str += ` <li data-id=${data[i].workid} class="feed-list-item"><img src="${data[i].cover}"></img></li>`
          }
          console.log(str, 'str')
          $('.feed-list').append(str)
        }

      },
      fail: function() {

      }

    })
  }
  new activity().init();
})(Zepto);
